import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackSessionStart } from '../utils/analytics';

interface AnalyticsTrackerProps {
  arrivalMode?: 'hotel' | 'cruise';
}

function AnalyticsTracker({ arrivalMode }: AnalyticsTrackerProps) {
  const location = useLocation();

  useEffect(() => {
    trackSessionStart();
    trackPageView(location.pathname, location.search, arrivalMode);
  }, [location.pathname, location.search, arrivalMode]);

  return null;
}

export default AnalyticsTracker;
